import * as React from "react";
import { useAsyncValue } from "react-router-dom";
import { IWidgetAnalyticsLoaderData } from "../loader";
import CustomChart from "@/components/custom-chart";
import {
  dateFormatterForPeriod,
  getAggregationPeriodForDates,
} from "@/api/analytics";

export interface IClicChartProps {}

export default function ClicChart(props: IClicChartProps) {
  const { timeSerie, period } = useAsyncValue() as Awaited<
    IWidgetAnalyticsLoaderData["analytics"]
  >;
  return (
    <CustomChart
      data={timeSerie}
      config={{
        clics: {
          label: "Clics",
          color: "hsl(var(--chart-1))",
        },
      }}
      xAxis="hour"
      formatter={
        dateFormatterForPeriod[getAggregationPeriodForDates(...period)]
      }
      areas={{
        clics: {
          type: "monotone",
        },
      }}
    />
  );
}
